/**
 * The BIS modal is effectively built in a way that requires a page load when switching products. To get around the limitation, we define helper methods to allow product changes to happen without a page refresh while keeping the integrity of the BIS functionality
 * API reference: https://help.backinstock.org/article/2303-javascript-api
 */

/**
 * Re-init BIS
 * @param {Object} product
 * @returns {void}
 */
const initBackInStock = product => {
  if (!product) {
    /* eslint-disable no-console */
    console.error('requires a product object to initialize the BIS');
  }
  // BIS requires a page load to initialize, so we need to re-init it when we section render
  if (typeof _BISConfig !== 'undefined') {
    // eslint-disable-next-line no-undef
    _BISConfig.product = product;
  }

  window.BIS && window.BIS.init();
};

const changeProduct = product => {
  if (!product) {
    /* eslint-disable no-console */
    console.error('requires a product object to initialize the BIS');
  }
  if (typeof _BISConfig !== 'undefined') {
    // eslint-disable-next-line no-undef
    _BISConfig.product = product;
  }
};

/**
 * Update the selected variant and open the BIS modal. If the BIS modal is not ready, retry up to 3 times with an exponential backoff
 * @param {Integer} variantId
 * @param {Object} product
 */
const updateBISVariant = (variantId, product) => {
  let retries = 3;
  let delay = 600;
  try {
    changeProduct(product);
    window.BIS.popup.form.selectVariant(variantId);
    window.BISPopover.show();
  } catch (error) {
    if (retries > 0) {
      retries--;
      setTimeout(() => {
        updateBISVariant(variantId, product);
        delay *= 2; // Double the delay for the next retry
      }, delay);
    } else {
      /* eslint-disable no-console */
      console.error(
        'Failed to select variant and show BIS popup after %d attempts',
        retries,
        error
      );
    }
  }
};

/**
 * Listen for the BIS popup modal event and update the selected variant
 * @returns {void}
 */
const BISEventListeners = () => {
  document.addEventListener('bis:popupModal', event => {
    const { variantId, product } = event.detail;
    updateBISVariant(variantId, product);
  });
};

export { initBackInStock, BISEventListeners };
